const agent = (state = "", action) => {
    switch(action.type){
        case 'AGENT_DATA_RECEIVED':
            return action.value;
        default :
            return state;
    }
};

const currency = (state = "USD", action) => {
    switch(action.type){
        case 'CURRENCY_CHANGED':
            return action.value;
        default:
            return state;
    }
};

const saveState = (state = false, action) => {
    switch(action.type){
        case 'SAVE_STATE_CHANGED':
            return action.value;
        default:
            return state;
    }
};

export { agent, currency, saveState}